import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ActiveRoute {
  activeRoute=signal('');
    setActiveRoute(fragment:string){
      
      this.activeRoute.set(fragment);
  }
  readActiveRoute(fragment:string){
    return this.activeRoute;
  }
}
